import { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  /** Tamanho do círculo. Default 'md'. */
  size?: 'sm' | 'md';
  /**
   * Rótulo acessível anunciado por leitores de tela. Quando o spinner está
   * acompanhado de texto visível, omita e deixe o texto fazer o anúncio
   * (o círculo vira decorativo via aria-hidden).
   */
  label?: string;
}

const SIZE_CLASSES: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-3.5 w-3.5 border-2',
  md: 'h-5 w-5 border-2',
};

/**
 * Loading circular na cor accent do sistema (E24.F2.T01). Anel com topo
 * transparente girando via animate-spin; sob prefers-reduced-motion a regra
 * global (index.css) reduz a animação a 1ms — o anel fica parado mas o
 * estado continua comunicado pelo texto/aria.
 */
export function Spinner({ size = 'md', label, className, ...props }: SpinnerProps) {
  return (
    <span
      {...(label ? { role: 'status', 'aria-label': label } : { 'aria-hidden': true })}
      className={cn(
        'inline-block animate-spin rounded-[50%] border-accent-600 border-t-transparent',
        SIZE_CLASSES[size],
        className,
      )}
      {...props}
    />
  );
}
